import { isTemplatePlaceholder } from '@/types';
import { RuleProperties } from '@react-awesome-query-builder/mui';
import { ListIdsFilter } from '@/types/searchFilterTypes';
import { AutocompleteGenericEntity } from '@australiangreens/ag-internal-components';
import { loadLists } from './listIdsLoader';
import type { FilterMapper, ValidationContext } from './filterMapperTypes';

export const ListIdsMapper: FilterMapper = {
  checkIsIncomplete({ value }) {
    const isNoListSelected = value[0].value.length === 0;
    return isNoListSelected;
  },
  toFilter({ value }: RuleProperties): ListIdsFilter {
    if (!value) throw new Error('Missing value');

    if (value.length !== 1) throw new Error('Invalid value. Expected array of length 1');

    const nestedValue = value[0].value;
    let mappedValue;
    if (isTemplatePlaceholder(nestedValue)) {
      mappedValue = nestedValue;
    } else {
      const lists = value[0] as { value: AutocompleteGenericEntity[] };

      mappedValue = lists.value.map(({ id }) => {
        if (typeof id !== 'number') throw new Error('Invalid value. Expect array of numbers');
        return id;
      });
    }

    return { name: 'listIds', value: mappedValue } as ListIdsFilter;
  },

  async fromFilter(filter: ListIdsFilter, { token }: ValidationContext) {
    if (isTemplatePlaceholder(filter.value)) {
      return {
        field: filter.name,
        operator: 'any in',
        value: [
          {
            value: filter.value,
            errors: [],
          },
        ],
      };
    }

    const { lists, isMissing } = await loadLists({ token, listIds: filter.value });

    return {
      field: filter.name,
      operator: 'any in',
      value: [
        {
          value: lists,
          errors: isMissing ? [{ field: 'lists', message: 'Missing lists' }] : [],
        },
      ],
    };
  },
};
